module.exports = __webpack_public_path__ + "img/fs_tool.ebc22dd4.png";